import React, { useState, useEffect, useMemo } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/button';
import ToggleRow from '../ToggleRow';
import SKCard from '../UI/SKCard';
import { SECTION_NAMES } from '@/data/faq';
import classes from './styles.module.scss';

export default function FAQ({ list, showLength = Infinity, isNotBlog, initialLang = 'en', onLangChange }) {
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    setLang(initialLang);
  }, [initialLang]);

  useEffect(() => {
    if (onLangChange) {
      onLangChange(lang);
    }
  }, [lang, onLangChange]);

  // Group FAQs by section
  const groupedFaqs = useMemo(() => {
    const groups = {};
    list.slice(0, showLength).forEach(faq => {
      const sectionKey = faq.sectionKey;
      if (!groups[sectionKey]) {
        groups[sectionKey] = [];
      }
      groups[sectionKey].push(faq);
    });
    return groups;
  }, [list, showLength]);

  const languageTabs = [
    { code: 'en', label: 'English' },
    { code: 'hi', label: 'हिंदी' },
    { code: 'mr', label: 'मराठी' },
    { code: 'gu', label: 'ગુજરાતી' },
    { code: 'id', label: 'Indonesian' }
  ];

  return (
    <div className={classes.faqContainer}>
      <div style={{ margin: '1rem 0rem' }}>
        <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
          {languageTabs.map(({ code, label }) => (
            <Button
              key={code}
              colorScheme={lang === code ? 'brand' : 'gray'}
              onClick={() => setLang(code)}
              bg={lang === code ? 'var(--primary-color)' : '#e2e8f0'}
              color={lang === code ? 'white' : '#4a5568'}
              _hover={{
                bg: lang === code ? 'var(--primary-color)' : '#cbd5e0'
              }}
            >
              {label}
            </Button>
          ))}
        </ButtonGroup>
      </div>

      <div className={classes.FaqList}>
        {Object.keys(groupedFaqs).map(sectionKey => (
          <div key={sectionKey}>
            <h2 className={classes.sectionTitle}>
              {SECTION_NAMES[sectionKey][lang]}
            </h2>
            {groupedFaqs[sectionKey].map(val => (
              <SKCard className={classes.card} id={`${val.key}`} key={val.key}>
                <ToggleRow
                  key={val.key}
                  header={<div className={classes.rowHeader}>{val[lang].title}</div>}
                  body={val[lang].desc}
                  defaultOpen={false}
                />
              </SKCard>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
